/**
 * Builds URLs for Primum media hosted on CloudFront, such as Content Library thumbnails
 * and downloads. Rive animations are not served from here: they ship inside the app.
 */

import { useMemo } from 'react';

import { env } from '@/util/env';

export function usePrimumAssets() {
  const cloudfrontDomain = env.EXPO_PUBLIC_CLOUDFRONT_DOMAIN;

  const assets = useMemo(
    () => ({
      /**
       * Get CloudFront URL for an asset
       * @param path - The asset path relative to the CDN domain (e.g., 'content-library/thumbnail.png')
       * @returns The full CloudFront URL
       */
      getCloudFrontUrl: (path: string): string => {
        if (!cloudfrontDomain) {
          throw new Error('CloudFront domain not configured');
        }

        return `https://${cloudfrontDomain}/${path}`;
      },

      /**
       * Check if CloudFront is available
       * @returns boolean indicating if CloudFront is configured
       */
      isCloudFrontAvailable: !!cloudfrontDomain,
    }),
    [cloudfrontDomain]
  );

  return assets;
}
